import { render } from "./IntroText.vue?vue&type=template&id=6df6fa15&scoped=true"
import script from "./IntroText.vue?vue&type=script&lang=js"
export * from "./IntroText.vue?vue&type=script&lang=js"

import "./IntroText.vue?vue&type=style&index=0&id=6df6fa15&scoped=true&lang=css"

import exportComponent from "/Users/danilomeulens/Projects/_sandbox/simpsonbay_geneology/source/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df6fa15"]])

export default __exports__